import { useSelector } from 'react-redux';
import { isToolActiveSelector } from '../../tool/selectors/tool.selectors';
import { Tool } from '../../tool/utils/tool.utils';
import { Plot } from '../contexts/plot.context';
import { LaddergramContainer } from './LaddergramContainer';
import { MinutePlot } from './MinutePlot';
import { PlotContainer } from './PlotContainer';
import { ThreeLeadPlot } from './ThreeLeadPlot';
import { booleanPreferenceSelector } from '../../auth/selectors/auth.selectors';

export const ThreeLeadPlotContainer: React.FC = () => {
  const isEpisodeMeasurementActive = useSelector(
    isToolActiveSelector(Tool.episodeMeasurement),
  );
  const isRulerActive = useSelector(isToolActiveSelector(Tool.ruler));
  const cursor = isEpisodeMeasurementActive
    ? 'not-allowed'
    : isRulerActive
    ? 'crosshair'
    : undefined;
  const showLaddergram = useSelector(
    booleanPreferenceSelector('showLaddergram'),
  );

  return (
    <PlotContainer style={{ cursor }} data-testid='three-lead-plot'>
      <ThreeLeadPlot />
      <MinutePlot>
        {showLaddergram && (
          <Plot>
            <LaddergramContainer />
          </Plot>
        )}
      </MinutePlot>
    </PlotContainer>
  );
};
